import { jsx as _jsx } from "react/jsx-runtime";
import { Oval } from "react-loader-spinner";
function LoadingOval({ width = "80", height = "80", className = "", }) {
    return (_jsx(Oval, { visible: true, height: height, width: width, color: "#1d4ed8", secondaryColor: "#2563eb", ariaLabel: "oval-loading", wrapperStyle: {}, wrapperClass: className }));
}
function FullLoading() {
    return (_jsx("div", { className: "wpqt-flex wpqt-h-screen-minus-top-bar wpqt-flex-col wpqt-items-center wpqt-justify-center", children: _jsx(LoadingOval, {}) }));
}
function Loading({ className, ovalSize, }) {
    const ovalProps = ovalSize ? { width: ovalSize, height: ovalSize } : {};
    return (_jsx("div", { className: `wpqt-flex wpqt-flex-col wpqt-items-center wpqt-justify-center ${className}`, children: _jsx(LoadingOval, Object.assign({}, ovalProps)) }));
}
export { FullLoading, Loading, LoadingOval };
